const awsmobile = {
  aws_app_analytics: "enable",
  aws_cognito_identity_pool_id: "ap-southeast-1:822528bb-d412-447a-95ff-624bfc107400",
  aws_cognito_region: "ap-southeast-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "dylan-monster-lab",
  aws_content_delivery_bucket_region: "ap-southeast-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "ap-southeast-1_d6Sw0By5R",
  aws_user_pools_mfa_type: "ON",
  aws_user_pools_web_client_id: "12s20ktr90isjh54pm02loubkv",
  Storage: {
    bucket: "lms-prod-common-bucket",
    region: "ap-southeast-1"
  },
  aws_role_arn: "arn:aws:iam::588942745518:role/LMS-Admin-user",
  API: {
    endpoints: [
      {
        name: "LMS_API",
        endpoint: "https://kq4f4hw6fg.execute-api.ap-southeast-1.amazonaws.com/prod",
        service: "apigateway",
        region: "ap-southeast-1"
      }
    ]
  }
};
export default awsmobile;
